// Capacitor refresh-token storage. Native plugin can throw on cold start — never let that hang boot.
import { Capacitor } from "@capacitor/core";
import { SecureStorage } from "@aparajita/capacitor-secure-storage";

const KEY = "lion_refresh_token";

export const isCapacitorClient = () => Capacitor.isNativePlatform();

const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const getStoredRefreshToken = async () => {
  if (!isCapacitorClient()) return null;
  try {
    const value = await SecureStorage.get(KEY);
    return value ? String(value) : null;
  } catch (_e) {
    await pause(200);
    try {
      const value = await SecureStorage.get(KEY);
      return value ? String(value) : null;
    } catch (_e2) {
      return null;
    }
  }
};

export const setStoredRefreshToken = async (token) => {
  if (!isCapacitorClient()) return;
  try {
    if (token) {
      await SecureStorage.set(KEY, token);
    } else {
      await SecureStorage.remove(KEY);
    }
  } catch (_e) {
    // ponytail: keychain blip — login/refresh can retry later
  }
};

export const clearStoredRefreshToken = async () => {
  if (!isCapacitorClient()) return;
  try {
    await SecureStorage.remove(KEY);
  } catch (_e) {
    // same as set — don't block logout/boot
  }
};
